@if (!mappedItem.isDeleted) {
    <mat-card class="main-card flex-col flex">
        <mat-card-header class="start-start flex-row">
            <div class="header-icons flex-row">
                <cb-lot-spec-colour-item-icons
                    [mappedItem]="mappedItem"
                ></cb-lot-spec-colour-item-icons>
            </div>
            <span class="mat-body-strong">{{ mappedItem.colourItem.name }}</span>
        </mat-card-header>
        <mat-card-content class="card-content cb-padding-top mat-card-content-row">
            <div class="flex-col flex">
                <cb-display-value-new
                    label="Colour"
                    [value]="mappedItem.name"
                ></cb-display-value-new>
                <cb-text-area
                    class="notes"
                    label="Notes"
                    [ngModel]="mappedItem.notes"
                    [readonly]="true"
                ></cb-text-area>
            </div>
            <div class="images flex-col">
                <cb-image-button class="flex" [baseUrl]="mappedItem.specColourItemImage">
                </cb-image-button>
            </div>
        </mat-card-content>
        <mat-divider class="card-divider"></mat-divider>
        <mat-card-actions class="center-right layoutGap-16">
            @if (uiActions.canChangeSpecification()) {
                <button mat-stroked-button color="accent" (click)="uiActions.editColourItem()">
                    Edit
                </button>
            }
            @if (uiActions.canChangeSpecification()) {
                <button mat-stroked-button (click)="uiActions.removeColourItem()">Remove</button>
            }
        </mat-card-actions>
    </mat-card>
}
